import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";
import { Helmet } from "react-helmet";
import logo_default from "../assets/logo_default.jpg";
import Cookies from "js-cookie";
import Pos_billing_transaction from "./pos-billing-transaction.jsx";
import { Verify_stafftype_account } from "../company_root/staff_account_root/verify_stafftype_account.js";
import Voucher_print from "./pos_billing_voucher_print.jsx";
import "./pos_billing.css";
import { MdArrowBackIosNew } from "react-icons/md";
export const seo = {
    title: "POS Stock | Aooz.in | Accounting Software | Payments, Staff Payments, Stocks, Inventory & Attendance",
    description:
        "A00z.in  POS Receipt is an advanced accounting software for businesses. Manage payments, staff payments, stocks, inventory, staff attendance, and generate digital share receipts. Available on both web and mobile for seamless business operations.",
    keywords:
        "AOOZ.in POS Receipt, accounting software, staff payments, employee payment management, business accounting app, payment management, stock tracking, inventory software, staff attendance system, online share receipt, web accounting app, mobile accounting app",
    url: "https://aooz.in",
    image: "https://aooz.in/assets/logo.png"
};

export default function Pos_billing_page() {
    const navigate = useNavigate();
    const [IsLoading2, setIsLoading2] = useState(true);
    const [titlemete, setTitlemete] = useState("");
    const [activeTab, setActiveTab] = useState("pos");
    const [keywordsmete, setKeywordsmete] = useState("");
    const [vouchersdata, setVouchersdata] = useState([]);
    const [account_status, setAccount_status] = useState(false);
    const servicetablename = "accountingfinancedb";
    //staff account verify
    const [checking, setChecking] = useState(true);
    const [staffstatus, setStaffstatus] = useState(false);
    const [mobileapp, setMobileapp] = useState(false);
    const [voucherselect, setVoucherselect] = useState(false);
    const [staffdata, setStaffdata] = useState([]);
    const [guid, setGuid] = useState("");
    const [cashierno, setCashierno] = useState();
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("uid");

        if (uid === null || uid === undefined || uid === "") {

            setVoucherselect(false);
        } else {
            setVoucherselect(true);

        }
    }, [window.location.search]);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setMobileapp(true);
            } else {
                setMobileapp(false);
            }
        };

        // Run once on mount
        handleResize();

        // Attach resize listener
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    useEffect(() => {
        const existingsessiontoken = Cookies.get("sessiontoken");
        const guids = Cookies.get("guid");
        if (existingsessiontoken !== null && existingsessiontoken !== undefined && guids !== null && guids !== undefined) {
            setGuid(guid);
        } else {
            navigate("/");
        }
    }, [navigate]);
    useEffect(() => {
        if (!guid) return;

        let isMounted = true; // ✅ prevent state update after unmount

        const verifyStaffAccount = async () => {
            try {
                setChecking(true);

                const result = await Verify_stafftype_account(guid);

                if (!isMounted) return;

                if (result?.success) {
                    setAccount_status(result.data.status);

                    setStaffdata({
                        staff: result.data,
                        accountinfo: result.accountinfo
                    });

                    setStaffstatus(true);
                } else {
                    setStaffstatus(false);
                }
            } catch (error) {
                console.error("Staff verification failed:", error);
                if (isMounted) setStaffstatus(false);
            } finally {
                if (isMounted) setChecking(false);
            }
        };

        verifyStaffAccount();

        return () => {
            isMounted = false;
        };
    }, [guid]);

    useEffect(() => {
        const guid = Cookies.get("guid");
        const select_company_uid = Cookies.get("select_company_uid");
        setIsLoading2(true);
        if (!select_company_uid) {
            console.error("No company selected");
            setIsLoading2(false); return;
        }
        const productQuery = query(collection(db, servicetablename, select_company_uid, "vouchers"),
            where("usecase_type", "==", true),
            where("voucher_ledger", "==", "user")
        );
        const unsubscribe = onSnapshot(productQuery, async (snapshot) => {
            const docs = snapshot.docs;
            const filtered = await Promise.all(docs.map(async (docSnap) => {
                const data = docSnap.data();
                const managerQ = query(collection(db,
                    servicetablename,
                    select_company_uid, "ledger_accounts_manager"),
                    where("voucherid", "==", data.voucherid),
                    where("ledger_type", "==", "manage"),
                    where("accountguid", "==", guid));
                const managerSnap = await getDocs(managerQ);
                if (managerSnap.empty) return null;
                return { id: docSnap.id, ...data };
            }));

            const finalData = filtered.filter(Boolean);
            setVouchersdata(finalData);
            setIsLoading2(false);
        }, (error) => {
            console.error("Error fetching vouchers:", error);
            setIsLoading2(false);
        }); return () => unsubscribe();
    }, []);

    const meta = {
        title: titlemete || seo.title,
        description: seo.description,
        keywords: keywordsmete || seo.keywords,
        image: seo.image,
        url: `https://aooz.in`,
    };
    const openVoucher = (uid) => {
        navigate(`/pos-billing?&uid=${uid}`, { state: { uid } });
    };

    return (
        <div>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <meta name="keywords" content={meta.keywords} />
                <meta property="og:title" content={meta.title} />
                <meta property="og:description" content={meta.description} />
                <meta property="og:image" content={meta.image} />
                <meta property="og:url" content={meta.url} />
            </Helmet>

            <div className="container_roots">
                <div className="items-back-fill-dark">

                    <div className="tabs-body  ">

                        <div
                            className={`tabsbutton p-11 ${activeTab === "pos" ? "active" : ""}`}
                            onClick={() => {
                                setActiveTab("pos");
                            }}
                        >
                            <span className="tabs-text text-h2">POS Billing</span>
                        </div>
                        <div
                            className={`tabsbutton p-11 ${activeTab === "openorders" ? "active" : ""}`}
                            onClick={() => {
                                setActiveTab("openorders");
                            }}
                        >
                            <span className="tabs-text text-h2">Open orders</span>
                        </div>
                        <div
                            className={`tabsbutton p-11 ${activeTab === "transaction" ? "active" : ""}`}
                            onClick={() => {
                                setActiveTab("transaction");
                            }}
                        >
                            <span className="tabs-text text-h2">Transaction</span>
                        </div>

                    </div>
                </div>
                <div className="container_roots">

                    {activeTab == "pos" && (

                        <div className="post-container">
                            {mobileapp == true && voucherselect == true && (

                                <></>
                            )}
                            {mobileapp == true && voucherselect == false && (

                                <div className="post_div p-1">

                                    {
                                        vouchersdata.length === 0 ? (
                                            <div className="text-h1 bold center" style={{ maxWidth: 720, margin: "0 auto" }}>
                                                You have not authorized any payment receipts at this time.
                                                <br />
                                                <span className="text-off text-h2" style={{ display: "block", marginTop: 8 }}>
                                                    If you need help or wish to authorize a receipt, please contact our support team.
                                                </span>
                                                <br />
                                                <div onClick={() => navigate("/support")} className="button-ui3 b-1 cursor  p-3 text-h1 fill">
                                                    Contact Support

                                                </div>
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    <div className="ui-grid-150">
                                        {IsLoading2 ? (
                                            <></>
                                        ) : vouchersdata.length === 0 ? (
                                            <></>
                                        ) : (
                                            vouchersdata.map((row) => (
                                                <div
                                                    className="ui-items items-back hover b-1 rounded cursor"
                                                    onClick={() => openVoucher(row.voucherid)}
                                                    key={row.id}
                                                >
                                                    <div className="pos-photo-div ">
                                                        <img
                                                            src={row.logo_url || logo_default}
                                                            alt={row.voucher}
                                                            className="pos-item-logo"
                                                        />
                                                        <div className="amt-div">
                                                            <table>
                                                                <tr>
                                                                    <td>
                                                                        <div className="text-h3 fcap ">{row.voucher_type}</div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-h3 bold text-r">
                                                                            <span className="text-off text-h3">₹</span>
                                                                            {row.amount || ""}
                                                                            <span className="text-off text-h3">/-</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </table>

                                                        </div>
                                                    </div>
                                                    <div >
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <div >
                                                                            <div className="text-h2 fcap bold">{row.voucher}</div>


                                                                            {row.child?.dealname && (
                                                                                <div>
                                                                                    <span className="red text-h3 items-back rounded-sm">
                                                                                        {row.child.dealname}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>

                                                                </tr>
                                                            </tbody>
                                                        </table>


                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>

                                </div>
                            )}

                            {mobileapp == false && (
                                <div className="post_div p-1">

                                    {
                                        vouchersdata.length === 0 ? (
                                            <div className="text-h1 bold center" style={{ maxWidth: 720, margin: "0 auto" }}>
                                                You have not authorized any payment receipts at this time.
                                                <br />
                                                <span className="text-off text-h2" style={{ display: "block", marginTop: 8 }}>
                                                    If you need help or wish to authorize a receipt, please contact our support team.
                                                </span>
                                                <br />
                                                <div onClick={() => navigate("/support")} className="button-ui3 b-1 cursor  p-3 text-h1 fill">
                                                    Contact Support

                                                </div>
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    <div className="ui-grid-200">
                                        {IsLoading2 ? (
                                            <></>
                                        ) : vouchersdata.length === 0 ? (
                                            <></>
                                        ) : (
                                            vouchersdata.map((row) => (
                                                <div
                                                    className="ui-items items-back b-1 hover rounded cursor"
                                                    onClick={() => openVoucher(row.voucherid)}
                                                    key={row.id}
                                                >
                                                    <div className="pos-photo-div">
                                                        <img
                                                            src={row.logo_url || logo_default}
                                                            alt={row.voucher}
                                                            className="pos-item-logo"
                                                        />
                                                        <div className="amt-div">
                                                            <table>
                                                                <tr>
                                                                    <td>
                                                                        <div className="text-h3 fcap ">{row.voucher_type}</div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-h3 bold text-r">
                                                                            <span className="text-off text-h3">₹</span>
                                                                            {row.amount || ""}
                                                                            <span className="text-off text-h3">/-</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </table>

                                                        </div>
                                                    </div>
                                                    <div  >
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <div >
                                                                            <div className="text-h2 fcap bold">{row.voucher}</div>


                                                                            {row.child?.dealname && (
                                                                                <div>
                                                                                    <span className="red text-h3 items-back rounded-sm">
                                                                                        {row.child.dealname}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>

                                                                </tr>
                                                            </tbody>
                                                        </table>


                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>

                                </div>
                            )}

                            <div className="post_pos">
                                {mobileapp === true && voucherselect === true && (
                                    <div>

                                        <div className="button-ui0 cursor p-2  text-h2  bold" onClick={() => setVoucherselect(false)}><MdArrowBackIosNew className="icon" /> Back new item</div>
                                        <Voucher_print />
                                    </div>
                                )}
                                {mobileapp == false && (
                                    <Voucher_print />
                                )}
                            </div>
                        </div>

                    )}
                    {activeTab == "openorders" && (
                        <>Open</>
                    )}

                    {activeTab == "transaction" && (
                        <Pos_billing_transaction />
                    )}
                </div>

            </div>
        </div>
    );
}
